export default __webpack_public_path__ + "static/media/bounce-back.4762310f.svg";